// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flexwrap .fleet-status[data-v-2831105d]{max-width:50%;margin-right:15px}.flexwrap .fleet-status[data-v-2831105d]:last-child{margin:0}.countbox[data-v-2831105d]{min-width:150px;width:12.5%;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
